import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import ContactForm from "../form/ContactForm";
import CookieConsent from "react-cookie-consent";

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <>
            <Header />
            <main>
                <div>
                    {children}
                </div>
                <section className="contact-form" id="contact-us">
                    <ContactForm />
                </section>
            </main>

            <Footer />
            <CookieConsent
                location="bottom"
                buttonText="I understand"
                expires={365} // The cookie expires in 365 days
            >
                This website uses cookies to enhance the user experience.{" "}
            </CookieConsent>
        </>
    );
}

export default Layout;